export default{
  "en": {
    "dxCollectionWidget-noDataText": "No data to display",
    "dxList-pullingDownText": "Pull down to refresh...",
    "dxList-pulledDownText": "Release to refresh...",
    "dxList-refreshingText": "Refreshing...",
    "dxList-pageLoadingText": "Loading...",
    "dxList-nextButtonText": "More",
    "dxList-selectAll": "Select All",
    "dxListEditDecorator-delete": "Delete",
    "dxListEditDecorator-more": "More",
    "dxDataGrid-headerFilterOK": "Apply",
    "dxDataGrid-headerFilterCancel": "Close",
    "dxDataGrid-ascendingText":"Ascending order",
    "OK": "OK", 
    "Cancel": "Cancel",
  },
  "ar": {
    "dxCollectionWidget-noDataText": "لا توجد بيانات للعرض",
    "dxList-selectAll": "اختيار الكل",
    "dxDataGrid-headerFilterOK": "حسنًا",
    "dxDataGrid-headerFilterCancel": "إلغاء",
    "dxDataGrid-sortingAscendingText": "فرز تصاعدي",
    "dxDataGrid-sortingDescendingText": "فرز تنازلي",
    "dxDataGrid-sortingClearText": "مسح الفرز",
    "OK": "تأكيد", 
    "Cancel": "إلغاء",
  },
  "es": {
    "dxCollectionWidget-noDataText": "No hay datos para mostrar",
    "dxList-selectAll": "Seleccionar todo",
    "dxDataGrid-headerFilterOK": "Aceptar",
    "dxDataGrid-headerFilterCancel": "Cancelar",
    "dxDataGrid-sortingAscendingText": "Orden Ascendente",
    "dxDataGrid-sortingDescendingText": "Orden Descendente",
    "dxDataGrid-sortingClearText": "Limpiar Ordenamiento",
  }
}
